// Market-aggregate PnL card share event — fires when a user shares
// their entire position on a market (across all outcomes held).
// Distinct from `pnl_card_shared` which fires for per-(market, outcome)
// shares so the funnel can attribute organic distribution to whichever
// surface (per-position flex vs market-aggregate flex) drove the click.

import type { EventDefinition } from './navigation';
import type { PnlCardSharedMethod } from './pnl-card-shared';

export type PnlMarketCardSharedProperties = {
  marketPubkey: string;
  walletPubkey: string;
  method: PnlCardSharedMethod;
};

export const PNL_MARKET_CARD_SHARED: EventDefinition<PnlMarketCardSharedProperties> = {
  name: 'pnl_market_card_shared',
};
